import React from 'react';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

const LoadingMembers = () => {
    return (
        <div className='zinantis-members__page'>
            <div className='flex flex-column gap-10'>
                <LoadingPlaceholder variant='text' sx={{ fontSize: '24px' }} />
                <LoadingPlaceholder
                    variant='rectangular'
                    width={'100%'}
                    height={32}
                />
            </div>
            <div
                className='flex-column gap-40 flex-grow'
                style={{
                    overflow: 'auto',
                }}
            >
                {Array.from({ length: 3 }, (_, i) => i).map(i => {
                    return (
                        <div key={i} className='flex-column gap-10'>
                            <LoadingPlaceholder
                                variant='text'
                                sx={{ fontSize: '24px' }}
                            />
                            <LoadingPlaceholder
                                variant='rectangular'
                                height={320}
                                width={'100%'}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LoadingMembers;
